import { compose } from 'recompose'
import { connect } from 'react-redux'
import { createHome } from '../../../actions/homeCreate'
import { createMarketInterest } from '../../../actions/buyerInfo'

const NewHomeWizardContainer = compose(
  connect(null, dispatch => ({
    createHome: home => {
      dispatch(createHome(home))
      dispatch(createMarketInterest(home.zipCode))
    }
  }))
)

export default NewHomeWizardContainer
